import { render, staticRenderFns } from "./BookmarkActivity.vue?vue&type=template&id=7c0f206a"
import script from "./BookmarkActivity.vue?vue&type=script&lang=js"
export * from "./BookmarkActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports